import { NavLink } from 'react-router-dom'
import { useLanguage } from '@i18n'
import './BottomNavigation.css'

const navItems = [
  {
    to: '/vessels',
    labelKey: 'common.vessels',
    iconClassName: 'bottom-nav__icon--home',
  },
  {
    to: '/qrcode',
    labelKey: 'common.scan',
    iconClassName: 'bottom-nav__icon--qr',
  },
  {
    to: '/help',
    labelKey: 'common.help',
    iconClassName: 'bottom-nav__icon--help',
  },
]

export const BottomNavigation = () => {
  const { t } = useLanguage()

  return (
    <nav className="bottom-nav" aria-label={t('common.primaryMobileNavigation')}>
      {navItems.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) => `bottom-nav__item ${isActive ? 'bottom-nav__item--active' : ''}`}
        >
          <span className={`bottom-nav__icon ${item.iconClassName}`} aria-hidden="true" />
          <span>{t(item.labelKey)}</span>
        </NavLink>
      ))}
    </nav>
  )
}

export default BottomNavigation
